import React from "react";

export interface PreferencesContextValue {
  hasAcceptedData: boolean;
  acceptData: () => void;
  hasEnabledAnalytics: boolean;
  enableAnalytics: () => void;
}

export const PreferencesContext = React.createContext<PreferencesContextValue>(
  null!
);
